import NewsItemSkeleton from "./NewsItemSkeleton";
import { Row } from "react-bootstrap";

function NewsFeedSkeleton() {
  return (
    <Row style={{ height: "100", overflow: "auto" }} className="p-2">
      {Array.from({ length: 3 }).map((_, index) => (
        <NewsItemSkeleton id={index} key={index} />
      ))}
    </Row>
  );
}

export default NewsFeedSkeleton;
